// extracted by mini-css-extract-plugin
export default {"AppCard":"AppCard_AppCard__NPTM5","AppCardIcon":"AppCard_AppCardIcon__ThrUl","AppCardDetails":"AppCard_AppCardDetails__HgNoY","CustomIcon":"AppCard_CustomIcon__+Tc3I"};